import { FC } from 'react';
import { Target } from 'lucide-react';
import MotionInView from '../../enhanced/MotionInView';
import { useLanguage } from '../../../contexts/LanguageContext';
import { companyInfo } from '../../../data/companyInfo';

const MissionSection: FC = () => {
  const { t } = useLanguage();
  
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mission */}
        <MotionInView>
          <div className="text-center mb-10">
            <div className="flex items-center justify-center mb-4">
              <Target className="h-12 w-12 text-blue-600" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{companyInfo.mission.title}</h2>
            <div className="mt-3 w-16 h-1 bg-blue-600 mx-auto rounded-full"></div>
          </div>
        </MotionInView>

        <MotionInView>
          <div className="mx-auto max-w-4xl text-lg leading-8 text-gray-700 space-y-6">
            <p className="text-center">
              {companyInfo.mission.description}
            </p>
          </div>
        </MotionInView>

        {/* Background */}
        <MotionInView>
          <div className="mt-12 mx-auto max-w-4xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">{companyInfo.background.title}</h3>
            <p className="text-lg text-gray-700 text-center">
              {companyInfo.background.description}
            </p>
          </div>
        </MotionInView>
      </div>
    </section>
  );
};

export default MissionSection;


